module.exports = __webpack_public_path__ + "static/szkjcyy-334c992488bd3dc4f18cab629f31623b.jpg";